import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteNavAnchor, PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './History.module.css';
import { DBDateField, DBTextArea, ToolTipBulb, DBDropDown, DBCheckBox } from '_components';
import { PatientCareCenterNoteSubjectiveMedHistory } from './MedHistory';
import { PatientCareCenterNoteSubjectiveMedHistoryPeds } from './MedHistoryPeds';
import { PatientCareCenterNoteSubjectivePedsHistory } from './PedsInformation';
import { PatientCareCenterNoteSubjectiveVitals } from './Vitals';
import { PatientCareCenterNoteSubjectivePrevTher } from './PrevTher';
import { PatientCareCenterNoteSubjectiveSocial } from './Social';
import { PatientCareCenterNoteSubjectiveCognition } from './Cognition';

class PatientCareCenterNoteSubjectiveHistory extends React.Component {

    formatSurgeryDate = (daysSinceSurgery) => {
        const weeks = Math.floor(daysSinceSurgery / 7);
        const days = daysSinceSurgery % 7;
        
        let result = '';

        if (weeks > 0) {
            result += `${weeks} week${weeks > 1 ? 's' : ''}`;
        }

        if (days > 0) {
            if (weeks > 0) {
            result += ', ';
            }
            result += `${days} day${days > 1 ? 's' : ''}`;
        }

        if (weeks === 0 && days === 0) {
            result = '0 days since surgery';
        } else {
            result += ' since surgery';
        }

        return result;
      }

      getDaysSinceSurgery = (surgeryDateStr) => {
        const surgeryDate = new Date(surgeryDateStr); 
        const currentDate = new Date();
        const diffTime = currentDate - surgeryDate; 
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 
        return diffDays;
      }

    render() {
        return (
            <PatientCareCenterNoteSection id='subj_history' name='History' level={1}>
                <PatientCareCenterNoteNavAnchor id='subj_hist' />
                {this.props.ntno === 1 && this.props.isPeds &&
                    <div className={styles.therapy_type_wrapper}>
                        <label className={styles.therapy_type_label}>Therapy Type:</label>
                        <span className={styles.therapy_type_field}>
                            <DBDropDown
                                className={styles.rating_drop_down}
                                noteId={this.props.noteId}
                                entity='PTEVALPEDS'
                                entityKeyColumn='EVPNO'
                                entityKeyValue={this.props.evpno}
                                field='EVPTTYNO'
                                masterEntity='PTTHERAPYTYPES'
                                masterEntityKeyColumn='TTYNO'
                                masterEntitySort='TTYNO'
                                masterEntityDisplay='TTYDESC'
                            />
                        </span>
                        <span className={styles.lightbulb_col} >
                            <ToolTipBulb uid={'SUB_HIST_' + this.props.noteId} position='left' width={300} size='small'>
                                Rehabilitative helps a patient improve their level of functioning from prior illness or injury. <br /> <br />
                                Habilitative helps a patient improve their level of functioning from their existing baseline.
                            </ToolTipBulb >
                        </span>
                    </div>
                }
                <div className={styles.date_wrapper}>
                    <label className={(this.props.isPeds) ? styles.onset_label_notreq : styles.onset_label}>Onset Date:</label>
                    <span className={styles.date_field_onSet}>
                        <DBDateField
                            noteId={this.props.noteId}
                            entity='CPEPISODE'
                            entityKeyColumn='EPNO'
                            entityKeyValue={this.props.epno}
                            maxDate={new Date()}
                            field='EPDTONST'
                        />
                    </span>

                    <label className={styles.surgery_label}>Surgery Date:</label>
                    <span className={styles.date_field}>
                        <DBDateField
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            maxDate={new Date()}
                            field='EVSUBHISSURGERYDATE'
                        />
                    </span>

                    <label className={styles.hospital_label}>Hospital DC:</label>
                    <span className={styles.date_field}>
                        <DBDateField
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            maxDate={new Date()}
                            field='EVSUBHISHOSPDCDATE'
                        />
                    </span>
                    <span className={styles.lightbulb_col} />
                </div>

                <div className={styles.date_wrapper}>
                    <label className={styles.onset_label_notreq}/>
                    
                    <label className={styles.surgery_label}/>
                    <span className={styles.date_detail}>
                        {this.props.surgeryDate !== null && this.props.surgeryDate !== undefined ? this.formatSurgeryDate(this.getDaysSinceSurgery(this.props.surgeryDate)): ""}
                    </span>

                    <label className={styles.hospital_label}/>
                    <span className={styles.date_field}/>
                    <span className={styles.lightbulb_col} />
                </div>

                <PatientCareCenterNoteNavAnchor id='subj_hist_details' />
                <div className={styles.details_wrapper} id='subj_hist_details'>
                    <label className={styles.details_label}>Details:</label>
                    <DBTextArea
                        rows={5}
                        className={styles.details_field}
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBHISDETAILS'
                    />
                    <span className={styles.lightbulb_col}>
                        <ToolTipBulb uid={'SUB_HIST_' + this.props.noteId} position='left' width={300} size='small'>
                            Insidious/MOI<br />
                            Chief Complaint<br />
                            Signs/Symptoms<br />
                            Test Results/Diagnostics<br />
                            PLOF/CLOF
                        </ToolTipBulb >
                    </span>

                </div>
                <div className={styles.checkbox_row}>
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVTELECONSENT' label='Patient has consented to be seen via telehealth on doxy.me' />
                </div>
                {this.props.isPeds &&
                    <>
                        <PatientCareCenterNoteSubjectiveMedHistoryPeds />
                        <PatientCareCenterNoteSubjectivePedsHistory />
                    </>
                }
                
                {
                    !this.props.isPeds &&
                    < PatientCareCenterNoteSubjectiveMedHistory />
                }

                <PatientCareCenterNoteSubjectiveVitals />
                {!this.props.isPeds &&
                    < PatientCareCenterNoteSubjectivePrevTher />
                }
                <PatientCareCenterNoteSubjectiveSocial />
                {!this.props.isPeds &&
                <PatientCareCenterNoteSubjectiveCognition />
                }

            </PatientCareCenterNoteSection >
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let ntno = parseInt(noteId.split("_")[0]);

    let evpno = Object.keys(state.entities.notes.PTEVALPEDS)
        //peds info
        .find(key => (state.entities.notes.PTEVALPEDS[key].EVPEVNO === evno));

    let epno = state.entities.admissions[state.entities.notes.PTEVAL[evno].EVEPNO]?.id;

    let isPeds = state.entities.admissions[state.entities.notes.PTEVAL[evno].EVEPNO].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
    if (!isPedsEnabled) {
        isPeds = isPedsEnabled;
    }

    return {
        noteId: noteId,
        evno: evno,
        epno: epno,
        isPeds,
        ntno,
        evpno,
        surgeryDate: state.entities.notes.PTEVAL[evno]?.EVSUBHISSURGERYDATE
    };
}

const connectedPatientCareCenterNoteSubjectiveHistory = connect(mapStateToProps)(PatientCareCenterNoteSubjectiveHistory);
export { connectedPatientCareCenterNoteSubjectiveHistory as PatientCareCenterNoteSubjectiveHistory };

